import * as React from "react";
import { Grid, GridColumn, Input } from "semantic-ui-react";
import "./project-new.css";
import MyDatePicker from "../../../components/date-picker/date-picker";
import LabeledInput from "../../../components/labeled-input/labeled-input";
import LabeledTextArea from "../../../components/labeled-textarea/labeled-textarea";
import { Contact } from "../../../stores/contact/contact-store";
import { KeyValueStore } from "../../../stores/key-value/key-value-store";
import { Municipality } from "../../../stores/municipality/municipality-store";
import { getDesc, getLabel } from "../../../reflection/reflection";
import { ConstructionPermitProject, DezoningProject } from "../../../stores/project/project";

export default function DezoningNew({
                                        municipalities,
                                        contacts,
                                        keyValueStore
                                    }: {
    municipalities: Municipality[];
    contacts: Contact[];
    keyValueStore: KeyValueStore
}): JSX.Element {
    return (
        <div>
            <Grid columns={2} relaxed={true} stackable={true}>
                <GridColumn largeScreen={16} widescreen={8}>
                    <LabeledInput
                        label="Name"
                        inputElement={<Input type="text" name="name" maxLength={50}/>}
                        required={true}
                    />
                    <LabeledInput
                        label={getLabel(DezoningProject.prototype, "municipalityName")}
                        desc={getDesc(DezoningProject.prototype, "municipalityName")}
                        inputElement={
                            <select name="municipality" className="ui selection dropdown">
                                <option disabled selected>
                                    -- Auswählen --
                                </option>
                                {municipalities.map((m) => (
                                    <option
                                        key={m.bfsNr}
                                        value={m.bfsNr}
                                    >
                                        {m.name}
                                    </option>
                                ))}
                            </select>
                        }
                        required={true}
                    />
                    <LabeledInput
                        label={getLabel(DezoningProject.prototype, "place")}
                        desc={getDesc(DezoningProject.prototype, "place")}
                        inputElement={<Input type="text" name="place"/>}
                    />
                    <LabeledInput
                        label={getLabel(DezoningProject.prototype, "revision")}
                        desc={getDesc(DezoningProject.prototype, "revision")}
                        inputElement={
                            <select name="revision" className="ui selection dropdown">
                                <option disabled selected>
                                    -- Auswählen --
                                </option>
                                {keyValueStore.revisionTypes.map((t) => (
                                    <option
                                        key={t.key}
                                        value={t.key}
                                    >
                                        {t.value}
                                    </option>
                                ))}
                            </select>
                        }
                        required={true}
                    />
                    <LabeledInput
                        label={getLabel(DezoningProject.prototype, "status")}
                        desc={getDesc(DezoningProject.prototype, "status")}
                        inputElement={
                            <select name="status" className="ui selection dropdown">
                                <option disabled selected>
                                    -- Auswählen --
                                </option>
                                {keyValueStore.projectStatuses.map((s) => (
                                    <option
                                        key={s.key}
                                        value={s.key}
                                    >
                                        {s.value}
                                    </option>
                                ))}
                            </select>
                        }
                        required={true}
                    />
                    <LabeledInput
                        label={getLabel(DezoningProject.prototype, "governmentCouncilDecisionNr")}
                        desc={getDesc(DezoningProject.prototype, "governmentCouncilDecisionNr")}
                        inputElement={<Input type="text" name="governmentCouncilDecisionNr"/>}
                    />
                    <LabeledInput
                        label={getLabel(DezoningProject.prototype, "enactmentDateDisplayText")}
                        desc={getDesc(DezoningProject.prototype, "enactmentDateDisplayText")}
                        inputElement={<MyDatePicker name="enactmentDate"/>}
                    />
                    <LabeledInput
                        label={getLabel(DezoningProject.prototype, "approvedCreationArea")}
                        desc={getDesc(DezoningProject.prototype, "approvedCreationArea")}
                        inputElement={<Input name="approvedCreationArea" type="number"/>}
                    />
                    <LabeledInput
                        label={getLabel(DezoningProject.prototype, "landOwnerFullName")}
                        desc={getDesc(DezoningProject.prototype, "landOwnerFullName")}
                        inputElement={
                            <select name="landOwnerId" className="ui selection dropdown">
                                <option key={-1} value="" selected>
                                    -- Auswählen --
                                </option>
                                {contacts.map(c => (
                                    <option
                                        key={c.id}
                                        value={c.id}
                                    >{`${c.firstName} ${c.lastName}`}</option>
                                ))}
                            </select>
                        }
                    />
                    <LabeledInput
                        label={getLabel(DezoningProject.prototype, "cmiDocumentsRawiPre")}
                        desc={getDesc(DezoningProject.prototype, "cmiDocumentsRawiPre")}
                        inputElement={<Input type="text" name="cmiNrRawiPre"/>}
                        required={true}
                    />
                    <LabeledInput
                        label={getLabel(DezoningProject.prototype, "cmiDocumentsUwePre")}
                        desc={getDesc(DezoningProject.prototype, "cmiDocumentsUwePre")}
                        inputElement={<Input type="text" name="cmiNrUwePre"/>}
                    />
                    <LabeledInput
                        label={getLabel(DezoningProject.prototype, "cmiDocumentsRawiApproved")}
                        desc={getDesc(DezoningProject.prototype, "cmiDocumentsRawiApproved")}
                        inputElement={<Input type="text" name="cmiNrRawiApproved"/>}
                    />
                    <LabeledInput
                        label={getLabel(DezoningProject.prototype, "cmiDocumentsUweApproved")}
                        desc={getDesc(DezoningProject.prototype, "cmiDocumentsUweApproved")}
                        inputElement={<Input type="text" name="cmiNrUweApproved"/>}
                    />
                </GridColumn>
                <GridColumn>
                    <LabeledInput
                        label={getLabel(DezoningProject.prototype, "geometrySource")}
                        desc={getDesc(DezoningProject.prototype, "geometrySource")}
                        inputElement={<Input type="text" maxLength={50} name="geometrySource"/>}
                    />
                    <LabeledInput
                        label={getLabel(DezoningProject.prototype, "geometrySourceDateDisplayText")}
                        desc={getDesc(DezoningProject.prototype, "geometrySourceDateDisplayText")}
                        inputElement={<MyDatePicker name="geometrySourceDate"/>}
                    />
                    <LabeledTextArea label={getLabel(DezoningProject.prototype, "generalRemarks")}
                                     name="generalRemarks"/>
                </GridColumn>
            </Grid>
        </div>
    );
}
